import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { forwardRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { changeTab } from "../__redux/slices/AppSlice";
import { MGLogo } from "../pages/Hero/Hero";
import "./header.scss";
import facebookIcon from "../assets/icons/facebook.svg";
import { getEvents } from "./api/api";

const Header = forwardRef((props, ref) => {
  const TabNames = {
    Store: "Store",
    Services: "Services",
    Events: "Events",
    "About Us": "About Us",
  };
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [logoPosition, setLogoPosition] = useState("stacked");
  const [isScrolled, setIsScrolled] = useState(false);
  const dispatch = useDispatch();
  const currentTab = useSelector((state) => state.appSlice.tabSelected);
  const [showEvents, setShowEvents] = useState(false);

  const checkForEvents = async () => {
    const events = await getEvents();
    setShowEvents(events.length !== 0);
  };
  useEffect(() => {
    checkForEvents();
  }, []);

  useEffect(() => {
    const SCROLL_THRESHOLD_VH = 30;
    const handleScroll = () => {
      const threshold = window.innerHeight * (SCROLL_THRESHOLD_VH / 100);
      setIsScrolled(window.scrollY > threshold);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setLogoPosition(window.innerWidth > 1100 ? "front" : "stacked");
    };

    // Set initial position
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLinkChange = (newLink) => {
    dispatch(changeTab(newLink));
    setIsSidebarOpen(!isSidebarOpen);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <header ref={ref} className={`header ${isScrolled ? "scrolled" : ""}`}>
        <div className="header-content">
          <Link
            to="/"
            onClick={() => {
              dispatch(changeTab(undefined));
              window.scrollTo(0, 0);
            }}
          >
            <MGLogo logoPosition="stacked" />
          </Link>
          <div
            className={`links-container fade-in ${isSidebarOpen ? "mobile-open" : ""}`}
          >
            <div className="close-icon" onClick={toggleSidebar}>
              <FontAwesomeIcon icon={faTimes} />
            </div>
            <Link
              to="/store"
              className={`header-link ${currentTab === TabNames.Store ? `active` : ``}`}
            >
              <h2 onClick={() => handleLinkChange(TabNames.Store)}>Store</h2>
            </Link>
            <Link
              to="/services"
              className={`header-link ${
                currentTab === TabNames.Services ? `active` : ``
              }`}
            >
              <h2 onClick={() => handleLinkChange(TabNames.Services)}>
                Rentals
              </h2>
            </Link>

            {showEvents && (
              <Link
                to="/events"
                className={`header-link ${
                  currentTab === TabNames.Events ? `active` : ``
                }`}
              >
                <h2 onClick={() => handleLinkChange(TabNames.Events)}>
                  Events
                </h2>
              </Link>
            )}
            <Link
              to="/about"
              className={`header-link ${
                currentTab === TabNames["About Us"] ? `active` : ``
              }`}
            >
              <h2 onClick={() => handleLinkChange(TabNames["About Us"])}>
                About Us
              </h2>
            </Link>
            <a
              href="https://www.facebook.com/people/Maple-Grove-Permaculture/100037322333641/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebookIcon} alt="facebook icon" />
            </a>
          </div>
          <div className="hamburger-icon" onClick={toggleSidebar}>
            <FontAwesomeIcon icon={faBars} />
          </div>
        </div>
      </header>
      {/* Mobile backdrop overlay */}
      {isSidebarOpen && (
        <div className="mobile-backdrop" onClick={toggleSidebar} />
      )}
    </>
  );
});

export default Header;
